import axios from 'axios';

// Get API URL
let API_URL = process.env.REACT_APP_API_URL;

// In production, use '/api' as base - Coolify's Traefik strips the first /api prefix,
// so requests go: /api/api/v1/... → Traefik strips /api → backend gets /api/v1/...
if (process.env.NODE_ENV === 'production') {
  API_URL = '/api';
} else if (!API_URL) {
  API_URL = 'http://localhost:8000'; // Fallback for local dev
}

// If page is served over HTTPS, ensure API calls also use HTTPS (only if absolute URL)
if (typeof window !== 'undefined' && window.location.protocol === 'https:' && API_URL.startsWith('http:')) {
  API_URL = API_URL.replace(/^http:/, 'https:');
}

// Build the base URL
let baseURL = `${API_URL}/api/v1`;

if (typeof window !== 'undefined' && window.location.protocol === 'https:' && baseURL.startsWith('http:')) {
  baseURL = baseURL.replace(/^http:/, 'https:');
}

console.log('API Base URL:', API_URL);
console.log('Full axios baseURL:', baseURL);

// Create axios instance with default config
const api = axios.create({
  baseURL: baseURL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor to force HTTPS on every request in production
api.interceptors.request.use(
  (config) => {
    console.log('API Request:', config.method?.toUpperCase(), config.url);
    if (config.data) {
      console.log('Request Data:', config.data);
    }

    // Force HTTPS if page is served over HTTPS
    if (typeof window !== 'undefined' && window.location.protocol === 'https:' && config.url) {
      config.url = config.url.replace(/^http:/, 'https:');
    }
    if (typeof window !== 'undefined' && window.location.protocol === 'https:' && config.baseURL) {
      config.baseURL = config.baseURL.replace(/^http:/, 'https:');
    }

    const token = localStorage.getItem('access_token');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    console.error('API Request Error:', error);
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors and refresh tokens
api.interceptors.response.use(
  (response) => {
    console.log('API Response:', response.status, response.config.url);
    return response;
  },
  async (error) => {
    console.error('API Response Error:', error.response?.status, error.response?.data || error.message);

    const originalRequest = error.config;

    // If error is 401 and we haven't tried to refresh yet
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('refresh_token');

        if (!refreshToken) {
          // No refresh token available, redirect to login
          localStorage.removeItem('access_token');
          localStorage.removeItem('refresh_token');
          localStorage.removeItem('user');
          window.location.href = '/login';
          return Promise.reject(error);
        }

        // Try to refresh the token
        const response = await axios.post(
          `${API_URL}/api/v1/auth/refresh`,
          {
            refresh_token: refreshToken
          }
        );

        const { access_token, refresh_token } = response.data;

        // Store new tokens
        localStorage.setItem('access_token', access_token);
        if (refresh_token) {
          localStorage.setItem('refresh_token', refresh_token);
        }

        // Retry original request with new token
        originalRequest.headers.Authorization = `Bearer ${access_token}`;
        return api(originalRequest);
      } catch (refreshError) {
        // Refresh failed, clear storage and redirect to login
        localStorage.removeItem('access_token');
        localStorage.removeItem('refresh_token');
        localStorage.removeItem('user');
        window.location.href = '/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default api;